var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{ref:"uploadRef",staticClass:"upload_box",attrs:{"drag":_vm.drag,"action":"","accept":_vm.uploadAccept,"before-upload":_vm.handleUpload,"limit":_vm.limit,"show-file-list":false}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }